import { Image } from "@nextui-org/react";
import SharedServiceInstance from "@/services/shared-service";

const PlayAudioPopUp = ({ selectedAudio, icon, setIsPlay }) => {
    return (
        <div className="flex items-center gap-5 z-[2000] px-2">
            <img
                src={SharedServiceInstance.getOptimizeImage(
                    selectedAudio.photo,
                    "small-post-view"
                )}
                alt="audio"
                width={100}
                height={50}
            />
            <span className="font-bold line-clamp-2">
                {selectedAudio.metaDescription}
            </span>
            <div
                onClick={() => {
                    setIsPlay((prevState) => !prevState);
                }}
            >
                {icon}
            </div>
        </div>
    );
};

export default PlayAudioPopUp;
